import React from "react";
import { Link, useParams } from "react-router-dom";
import { courseRegistry } from "../../../courses/courseRegistry.js";
import Admin from "../../Admin/Admin.jsx";
import { hasAccess } from "../../../utils/permissions.js";
//import { levelContentData } from "../LevelContentData.js";
import { mergedAccumulatedLevels } from "./merged.js";
import { videoTitle, docTitle, utilsTitle } from "../../../utils/titles.js";
import { slugify } from "../../../utils/slugify.js";
import "./DashboardContent.css";
import { useTranslation } from "../../../utils/hooks/translateHook.js";
//import { useLevelContentData } from "../../../utils/hooks/translateLevelContentDataHook.js";

const LevelContent = ({ user }) => {  
  const t = useTranslation(); 
  const {courseSlug} = useParams();
  const courseConfig = courseRegistry[courseSlug];
  const levelContentData = courseConfig.levelContentData;
  
  if (user.subscriptionLevel === 9999) return <Admin />;

 

  const userLevelContent = levelContentData
    .slice()
    .sort((a, b) => b.level - a.level)
    .find((item) => hasAccess(user, item.level));

  const allMerged = mergedAccumulatedLevels(levelContentData);
  const mergedForUser = allMerged.filter(
    (item) => item.level <= userLevelContent.level
  );


  // Deduplicate subjects by title (keep only first one)
  const subjectMap = new Map();
  mergedForUser.forEach((item) => {
    (item.subjects || []).forEach((subject) => {
      const title = subject.title?.trim() || "Untitled";
      if (!subjectMap.has(title)) {
        subjectMap.set(title, subject);
      }
    });
  });
  const allSubjects = Array.from(subjectMap.values());

  const accessibleLevels = levelContentData
    .filter((item) => hasAccess(user, item.level) && item.level !== 9999)
    .sort((a, b) => a.level - b.level);

  const allContentItems = accessibleLevels.flatMap((item) => item.contentItems || []);
  const uniqueItems = [...new Set(allContentItems)];

  return (
    <div className="dashcontent-section">
      <h2 className="dashcontent-title">{userLevelContent?.title}</h2>
      <p className="dashcontent-intro">{userLevelContent?.description}</p>

      <div className="dashcontent-info">
        <div className="dashsection-items">
          <strong className="dashsection-heading">Content Items:</strong>
          <ul className="dashcontentItems-list">
            {uniqueItems.map((item, idx) => (
              <li key={idx} className="dashcontentItems-item">
                <img  alt="plus icon" className="plus-icon" />
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="dashcontent-card">
        {/* Videos */}
        {allSubjects.some((subject) => subject.videos?.length > 0) && (
          <div className="section-videos">
            <strong className="section-heading">LESSONS:</strong>
            {allSubjects.map((subject, idx) =>
              subject.videos?.length > 0 ? (
                <div key={idx}>
                  <h4>{subject.title} LESSONS</h4>
                  <ul className="videos-list">
                    {subject.videos
                      .filter((filename) => typeof filename === "string" && filename.trim() !== "")
                      .map((filename, i) => (
                        <li key={i} className="video-item">
                          <Link to={`/videos/${slugify(filename)}`} className="dash-video-link">
                            {videoTitle(filename)}
                          </Link>
                        </li>
                      ))}
                  </ul>
                </div>
              ) : null
            )}
          </div>
        )}

        {/* Documents */}
        {allSubjects.some((subject) => subject.docs?.length > 0) && (
          <div className="section-docs">
            <strong className="section-heading">DOCUMENTS & READING</strong>
            {allSubjects.map((subject, idx) =>
              subject.docs?.length > 0 ? (
                <div key={idx}>
                  <h4>{subject.title} Reading Sources</h4>
                  <ul className="docs-list">
                    {subject.docs
                      .filter((filename) => typeof filename === "string" && filename.trim() !== "")
                      .map((filename, i) => (
                        <li key={i} className="doc-item">
                          <Link to={`/docs/${slugify(filename)}`} className="dash-doc-link">
                            {docTitle(filename)}
                          </Link>
                        </li>
                      ))}
                  </ul>
                </div>
              ) : null
            )}
          </div>
        )}

        {/* Utilities  - hiding for now will think if necessary*/}
        {/* {allSubjects.some((subject) => subject.utils?.length > 0) && (
          <div className="section-utils">
            <strong className="section-heading">UTILITIES:</strong>
            {allSubjects.map((subject, idx) =>
              subject.utils?.length > 0 ? (
                <div key={idx}>
                  <h4>{subject.title} Utilities</h4>
                  <ul className="utils-list">
                    {subject.utils
                      .filter((filename) => typeof filename === "string" && filename.trim() !== "")
                      .map((filename, i) => (
                        <li key={i} className="util-item">
                          <Link to={`/utils/${slugify(filename)}`} className="dash-util-link">
                            {utilsTitle(filename)}
                          </Link>
                        </li>
                      ))}
                  </ul>
                </div>
              ) : null
            )}
          </div>
        )} */}
      </div>
    </div>
  );
};

export default LevelContent;
